import styled from "styled-components"
import Typography from "@material-ui/core/Typography"

const StaticTypography = styled(Typography)`
  margin-top: 3rem;
`

export default StaticTypography
